export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 rounded-full bg-primary-500"></div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
            联系我们
          </h2>
        </div>
        <div className="bg-background-100 rounded-2xl border border-background-200/60 p-6 md:p-10">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-12">
            <div className="flex-1">
              <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-900">
                有意见或建议？欢迎联系我们
              </h3>
              <p className="text-foreground-600 text-sm mt-3 leading-relaxed">
                如果你有任何关于白云视频的意见、建议或资源反馈，欢迎通过以下方式联系我们。
                我们重视每一位影迷的声音，共同打造更好的观影平台。
              </p>
              <div className="mt-6 space-y-3">
                <div className="flex items-center gap-3 text-sm text-foreground-600">
                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-100 text-primary-500 shrink-0">
                    <i className="ri-mail-line"></i>
                  </div>
                  <span>feedback@baiyunvideo.com</span>
                </div>
                <div className="flex items-center gap-3 text-sm text-foreground-600">
                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-100 text-accent-500 shrink-0">
                    <i className="ri-chat-smile-2-line"></i>
                  </div>
                  <span>在线客服：工作日 9:00-18:00</span>
                </div>
                <div className="flex items-center gap-3 text-sm text-foreground-600">
                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-500 shrink-0">
                    <i className="ri-file-text-line"></i>
                  </div>
                  <span>资源投稿与合作：content@baiyunvideo.com</span>
                </div>
              </div>
            </div>
            <div className="flex-1">
              <form className="space-y-4" onSubmit={(e) => e.preventDefault()}>
                <div>
                  <label className="block text-sm font-medium text-foreground-700 mb-1.5">你的昵称</label>
                  <input
                    type="text"
                    name="name"
                    className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                    placeholder="请输入昵称"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-foreground-700 mb-1.5">电子邮箱</label>
                  <input
                    type="email"
                    name="email"
                    className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                    placeholder="请输入邮箱"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-foreground-700 mb-1.5">反馈内容</label>
                  <textarea
                    name="message"
                    rows={4}
                    maxLength={500}
                    className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors resize-none"
                    placeholder="请描述你的意见或建议..."
                  ></textarea>
                </div>
                <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly className="form-anti-spam" />
                <button
                  type="submit"
                  className="whitespace-nowrap w-full py-3 rounded-lg bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 transition-colors duration-200 cursor-pointer"
                >
                  提交反馈
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}